export default __webpack_public_path__ + "assets/images/f3ed6818a3e844d711bccae19f13898d.png";